import React, {Component} from 'react';
import {connect} from 'react-redux';
import {isNumber} from 'lodash';
import {Card, Button, Form, Table, Loader, Label} from 'semantic-ui-react';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {paths} from '../../../common/dictionaries/urls';
import {Actions} from '../../../common/actions';
import CampaignByChassisTable from './CampaignByChassisTable';
import SearchForm from './SearchForm';
import './styles.scss';

class CampaignAndChassisQuery extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'chassis': '',
      'countRows': 0,
    };
  }

  componentDidMount() {
    if (!hasAccessPermission(this.props.permissions, resources.CampaignAndChassisServices, scopes.See)) {
      this.props.navigateTo(paths.AccessDenied);
    }
  }

  componentWillUnmount() {
    this.props.clearCampaignChassisList();
    this.props.clearCampaignListByChassis();
  }

  handleSearch = () => {
    const {chassis} = this.state;
    this.props.fetchCampaignsListByChassis(chassis);
  };

  handleChange = (field, value) => {
    const parseValue = isNumber(value) && !isNaN(value) ? value : value.toUpperCase();
    this.setState({
      [field]: parseValue,
    });
  };

  renderLoader() {
    return (
      <Table striped className='toyota-grid'>
        <Table.Body>
          <Table.Row>
            <Table.Cell colSpan='100%'>
              <Loader active inline='centered' content='Cargando resultados...' />
            </Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table>
    );
  }

  render() {
    const {isUserTde, campaignList, loading, chassisList, loadingChassisList} = this.props;
    const {countRows, chassis} = this.state;

    return (
      <div className='campaign-container'>
        <Card raised fluid>
          <div className='title-bar'>
            <div className='title'>
              <h2>Consulta de Campañas por Chassis</h2>
              <Label className='campaign-total' color='red' size='large'>
                Total campañas
                <Label.Detail>{countRows}</Label.Detail>
              </Label>
            </div>
          </div>
        </Card>
        <Card raised fluid>
          <div className='search-container'>
            <Form>
              <label className='invoice-b-10'>Búsqueda de campañas</label>
              <Form.Group widths='equal'>
                <SearchForm
                  {...this.state}
                  chassisList={chassisList}
                  loadingChassisList={loadingChassisList}
                  handleChange={this.handleChange}
                />
                <div className='twc-btn-search'>
                  <Button
                    disabled={chassis === '' || loading}
                    loading={loadingChassisList}
                    onClick={this.handleSearch}
                    type='submit'
                    color='green'
                  >
                    BUSCAR
                  </Button>
                </div>
              </Form.Group>
            </Form>
          </div>
        </Card>
        <Card raised fluid className='campaign-by-chassis-table'>
          {loading ? (
            this.renderLoader()
          ) : (
            <CampaignByChassisTable
              dataTable={campaignList}
              loading={loading}
              countRows={countRows}
              isUserTde={isUserTde}
              handleChange={this.handleChange}
            />
          )}
        </Card>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'permissions': state.session.permissions,
    'isUserTde': state.session.isUserFromTDE,
    'campaignList': state.campaignQuery.list,
    'loading': state.campaignQuery.loading,
    'chassisList': state.campaignQuery.chassisList,
    'loadingChassisList': state.campaignQuery.loadingChassisList,
  };
};

const {
  withRouter,
  navigateTo,
  clearCampaignChassisList,
  clearCampaignListByChassis,
  fetchCampaignsListByChassis,
} = Actions;

const mapDispatchToProps = {
  navigateTo,
  clearCampaignChassisList,
  clearCampaignListByChassis,
  fetchCampaignsListByChassis,
};

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(CampaignAndChassisQuery));
